import StaticContentService from "./StaticContentService";

export default StaticContentService;
